export class ZiathRequest
{
    host: string;
    port: string;
    scanProgramName : string;
}
